
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObcProgressIndicatorDots as ObcProgressIndicatorDotsElement} from '@oicl/openbridge-webcomponents/dist/components/progress-indicator-dots/progress-indicator-dots.js';
 
 
 

 
 export const ObcProgressIndicatorDots = createComponent({
   react: React,
   tagName: 'obc-progress-indicator-dots',
   elementClass: ObcProgressIndicatorDotsElement,
   events: {
     
   }
  });
 
 